module.exports = __webpack_public_path__ + "static/img/企业logo3.d93b2587.png";